// import FalconLightBoxGallery from "components/common/FalconLightBoxGallery";
// import IconButton from "components/common/IconButton";
// import React, { useEffect, useState } from "react";
// import { Col, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";

// import img1 from "assets/img/generic/4.jpg";
// import img2 from "assets/img/generic/5.jpg";
// import img11 from "assets/img/generic/11.jpg";
// import img3 from "assets/img/gallery/4.jpg";
// import img4 from "assets/img/gallery/5.jpg";
// import img5 from "assets/img/gallery/3.jpg";
// import UploadFilesModal from "./add-lab-report/UploadReports";
// import { CONSTANT_ROUTES } from "routes";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import { LabTestsAPI } from "api";

// export default function GalleryView() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [images, setImages] = useState([img1, img2]);
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await LabTestsAPI.get({
//           params: {
//             patientId: location?.state?.id ?? Number.MAX_SAFE_INTEGER,
//           },
//         });
//         setData(response?.data?.data ?? []);
//       } catch (error) {
//         console.error("Failed to fetch lab tests:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   return (
//     <div>
//       <div className="d-flex justify-content-between align-items-center  bg-body-tertiary mb-2 p-3">
//         <h6 className="fs-10 mb-0 text-nowrap py-2 py-xl-0 ">Lab Reports</h6>
//         <div className="d-flex gap-2">
//           <OverlayTrigger
//             overlay={
//               <Tooltip
//                 style={{ position: "fixed" }}
//                 id="overlay-trigger-example"
//               >
//                 New
//               </Tooltip>
//             }
//           >
//             <IconButton
//               variant="falcon-default"
//               size="sm"
//               icon="plus"
//               transform="shrink-3"
//               onClick={() =>
//                 navigate(CONSTANT_ROUTES.ADD_NEW_LAB_REPORT, {
//                   state: {
//                     patientId: location?.state && location?.state.id,
//                     patientName: location?.state?.name,
//                   },
//                 })
//               }
//             >
//               <span className="d-none d-sm-inline-block ms-1">New</span>
//             </IconButton>
//           </OverlayTrigger>
//         </div>
//       </div>
//       <FalconLightBoxGallery images={images}>
//         {(setImgIndex) => (
//           <Row className="g-2">
//             <Col xs={6}>
//               <Image
//                 src={images[0]}
//                 fluid
//                 rounded
//                 className="cursor-pointer"
//                 onClick={() => setImgIndex(0)}
//               />
//             </Col>
//             <Col xs={6}>
//               <Image
//                 src={images[1]}
//                 fluid
//                 rounded
//                 className="cursor-pointer"
//                 onClick={() => setImgIndex(1)}
//               />
//             </Col>
//             <Col xs={4}>
//               <Image
//                 src={images[2]}
//                 fluid
//                 rounded
//                 className="cursor-pointer"
//                 onClick={() => setImgIndex(2)}
//               />
//             </Col>
//             <Col xs={4}>
//               <Image
//                 src={images[3]}
//                 fluid
//                 rounded
//                 className="cursor-pointer"
//                 onClick={() => setImgIndex(3)}
//               />
//             </Col>
//             <Col xs={4}>
//               <Image
//                 src={images[4]}
//                 fluid
//                 rounded
//                 className="cursor-pointer"
//                 onClick={() => setImgIndex(4)}
//               />
//             </Col>
//           </Row>
//         )}
//       </FalconLightBoxGallery>

//     </div>
//   );
// }

// import FalconLightBoxGallery from "components/common/FalconLightBoxGallery";
// import IconButton from "components/common/IconButton";
// import React, { useEffect, useState } from "react";
// import { Col, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
// import { FaFilePdf, FaImage } from "react-icons/fa";
// import { FaFileWord, FaFileExcel } from "react-icons/fa6";
// import UploadFilesModal from "./add-lab-report/UploadReports";
// import { CONSTANT_ROUTES } from "routes";
// import { useNavigate, useLocation } from "react-router-dom";
// import { LabTestsAPI } from "api";
// import pdfMock from "../../../../../assets/img/icons/pdf.png";
// import docMock from "../../../../../assets/img/icons/docs.png";
// import xlsMock from "../../../../../assets/img/icons/xls.png";
// import fileMock from "../../../../../assets/img/icons/jpg.png";
// import Tippy from "@tippyjs/react";
// import "tippy.js/dist/tippy.css";
// import { BASEURL } from "utils/customConfig";

// export default function GalleryView() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [data, setData] = useState([]);
//   const [lightboxImages, setLightboxImages] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await LabTestsAPI.get({
//           params: {
//             patientId: location?.state?.id ?? Number.MAX_SAFE_INTEGER,
//           },
//         });
//         const files = response?.data?.data ?? [];
//         setData(files);

//         // Prepare images for Lightbox
//         const imageFiles = files.filter((file) =>
//           /\.(jpg|jpeg|png|gif)$/i.test(file.filePath)
//         );
//         setLightboxImages(
//           imageFiles.map((file) => file.filePath.replace(/\\/g, "/"))
//         );
//       } catch (error) {
//         console.error("Failed to fetch lab tests:", error);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleClick = (filePath) => {
//     const cleanPath = filePath.replace(/\\/g, "/");
//     if (/\.(jpg|jpeg|png|gif)$/i.test(cleanPath)) {
//       const imgIndex = lightboxImages.findIndex((img) => img === cleanPath);
//       if (imgIndex >= 0)
//         window.dispatchEvent(
//           new CustomEvent("openLightbox", { detail: imgIndex })
//         );
//     } else {
//       window.open(cleanPath, "_blank");
//     }
//   };

//   const renderIcon = (filePath) => {
//     const lower = filePath.toLowerCase();
//     if (/\.(jpg|jpeg|png|gif)$/i.test(lower)) return <FaImage size={66} />;
//     if (/\.pdf$/i.test(lower)) return <FaFilePdf size={66} />;
//     if (/\.docx?$/i.test(lower)) return <FaFileWord size={66} />;
//     if (/\.xlsx?$/i.test(lower)) return <FaFileExcel size={66} />;
//     return null;
//   };

//   const renderFilePreview = (filePath) => {
//     const fileUrl = filePath.replace(/\\/g, "/").trim().toLowerCase();

//     if (/\.(jpg|jpeg|png|gif)$/i.test(fileUrl)) {
//       return (
//         <Image
//           src={fileMock}
//           rounded
//           width={128}
//           height={128}
//           style={{
//             objectFit: "cover",
//             // border: "1px solid #ccc"
//           }}
//           alt="preview"
//         />
//       );
//     }

//     let mockImg = fileMock;
//     if (/\.pdf$/i.test(fileUrl)) mockImg = pdfMock;
//     else if (/\.docx?$/.test(fileUrl)) mockImg = docMock;
//     else if (/\.xlsx?$/.test(fileUrl)) mockImg = xlsMock;

//     return (
//       <Image
//         src={mockImg}
//         rounded
//         width={128}
//         height={128}
//         style={{
//           objectFit: "contain",
//           // border: "1px solid #ccc",
//           // backgroundColor: "#f8f9fa",
//         }}
//         alt="file preview"
//       />
//     );
//   };

//   return (
//     <div>
//       {/* <div className="d-flex justify-content-between align-items-center  bg-body-tertiary mb-2 p-3">
//         <h6 className="fs-10 mb-0 text-nowrap py-2 py-xl-0 ">Lab Reports</h6>
//         <div className="d-flex gap-2">
//           <OverlayTrigger
//             overlay={<Tooltip id="overlay-trigger-example">New</Tooltip>}
//           >
//             <IconButton
//               variant="falcon-default"
//               size="sm"
//               icon="plus"
//               transform="shrink-3"
//               onClick={() =>
//                 navigate(CONSTANT_ROUTES.ADD_NEW_LAB_REPORT, {
//                   state: {
//                     patientId: location?.state?.id,
//                     patientName: location?.state?.name,
//                   },
//                 })
//               }
//             >
//               <span className="d-none d-sm-inline-block ms-1">New</span>
//             </IconButton>
//           </OverlayTrigger>
//         </div>
//       </div> */}

//       <div className="d-flex justify-content-end mb-2 gap-2">
//         <OverlayTrigger
//           overlay={<Tooltip id="overlay-trigger-example">New</Tooltip>}
//         >
//           <IconButton
//             variant="falcon-default"
//             size="sm"
//             icon="plus"
//             transform="shrink-3"
//             onClick={() =>
//               navigate(CONSTANT_ROUTES.ADD_NEW_LAB_REPORT, {
//                 state: {
//                   patientId: location?.state?.id,
//                   patientName: location?.state?.name,
//                 },
//               })
//             }
//           >
//             <span className="d-none d-sm-inline-block ms-1">New</span>
//           </IconButton>
//         </OverlayTrigger>
//       </div>

//       <FalconLightBoxGallery images={lightboxImages}>
//         {(setImgIndex) => {
//           window.addEventListener("openLightbox", (e) => setImgIndex(e.detail));
//           return (
//             <Row className="g-2">
//               {data.map((item) => {
//                 const cleanPath = item.filePath.replace(/\\/g, "/");

//                 return (
//                   <Col xs={12} md={2} key={item.id}>
//                     <Tippy
//                       content={renderTooltipContent(item)}
//                       placement="top"
//                       interactive={true} // allows hover interaction inside tooltip
//                       delay={[200, 300]}
//                       maxWidth="none" // ✅ disables clipping
//                       theme="light-border"
//                     >
//                       <div
//                         className="p-2 text-center cursor-pointer"
//                         onClick={() =>
//                           handleClick(`${BASEURL}${item.relativeFilePath}`)
//                         }
//                       >
//                         <div className="mb-2 fw-semibold text-dark">
//                           {item.testName}
//                         </div>
//                         {renderFilePreview(item.filePath || "")}
//                       </div>
//                     </Tippy>
//                   </Col>
//                 );
//               })}
//             </Row>
//           );
//         }}
//       </FalconLightBoxGallery>
//     </div>
//   );
// }

// const renderTooltipContent = (item) => (
//   <div style={{ padding: "8px", maxWidth: "600px" }}>
//     <table style={{ tableLayout: "auto", width: "100%" }}>
//       <tbody>
//         <tr>
//           <th
//             style={{
//               textAlign: "left",
//               paddingRight: "1rem",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Test Date:
//           </th>
//           <td>{item.testDate?.split("T")[0]}</td>
//         </tr>
//         <tr>
//           <th
//             style={{
//               textAlign: "left",
//               paddingRight: "1rem",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Results:
//           </th>
//           <td>{item.results}</td>
//         </tr>
//         <tr>
//           <th
//             style={{
//               textAlign: "left",
//               paddingRight: "1rem",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Notes:
//           </th>
//           <td>{item.notes}</td>
//         </tr>
//         <tr>
//           <th
//             style={{
//               textAlign: "left",
//               paddingRight: "1rem",
//               whiteSpace: "nowrap",
//             }}
//           >
//             Normal Range:
//           </th>
//           <td>{item.normalRange}</td>
//         </tr>
//       </tbody>
//     </table>
//   </div>
// );

import FalconLightBoxGallery from "components/common/FalconLightBoxGallery";
import IconButton from "components/common/IconButton";
import React, { useEffect, useState } from "react";
import { Col, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { FaFilePdf, FaImage } from "react-icons/fa";
import { FaFileWord, FaFileExcel } from "react-icons/fa6";
import UploadFilesModal from "./add-lab-report/UploadReports";
import { CONSTANT_ROUTES } from "routes";
import { useNavigate, useLocation } from "react-router-dom";
import { LabTestsAPI } from "api";
import pdfMock from "../../../../../assets/img/icons/pdf.png";
import docMock from "../../../../../assets/img/icons/docs.png";
import xlsMock from "../../../../../assets/img/icons/xls.png";
import fileMock from "../../../../../assets/img/icons/jpg.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { BASEURL } from "utils/customConfig";

export default function GalleryView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [lightboxImages, setLightboxImages] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await LabTestsAPI.get({
          params: {
            patientId: location?.state?.id ?? Number.MAX_SAFE_INTEGER,
          },
        });
        const files = response?.data?.data ?? [];
        setData(files);

        // Prepare image URLs for lightbox
        const imageFiles = files.filter((file) =>
          /\.(jpg|jpeg|png|gif)$/i.test(file.relativeFilePath)
        );
        setLightboxImages(
          imageFiles.map((file) => `${BASEURL}${file.relativeFilePath}`)
        );
      } catch (error) {
        console.error("Failed to fetch lab tests:", error);
      }
    };

    fetchData();
  }, []);

  const handleClick = (relativePath) => {
    const fullPath = `${BASEURL}${relativePath}`;
    if (/\.(jpg|jpeg|png|gif)$/i.test(relativePath)) {
      const imgIndex = lightboxImages.findIndex((img) => img === fullPath);
      if (imgIndex >= 0)
        window.dispatchEvent(
          new CustomEvent("openLightbox", { detail: imgIndex })
        );
    } else {
      window.open(fullPath, "_blank");
    }
  };

  const renderFilePreview = (relativePath = "") => {
    const lowerPath = relativePath.trim().toLowerCase();

    if (/\.(jpg|jpeg|png|gif)$/i.test(lowerPath)) {
      return (
        <Image
          src={`${BASEURL}${relativePath}`}
          rounded
          width={128}
          height={128}
          style={{ objectFit: "cover" }}
          alt="preview"
        />
      );
    }

    let mockImg = fileMock;
    if (/\.pdf$/i.test(lowerPath)) mockImg = pdfMock;
    else if (/\.docx?$/i.test(lowerPath)) mockImg = docMock;
    else if (/\.xlsx?$/i.test(lowerPath)) mockImg = xlsMock;

    return (
      <Image
        src={mockImg}
        rounded
        width={128}
        height={128}
        style={{ objectFit: "contain" }}
        alt="file preview"
      />
    );
  };

  return (
    <div>
      <div className="d-flex justify-content-end mb-2 gap-2">
        <OverlayTrigger
          overlay={<Tooltip id="overlay-trigger-example">New</Tooltip>}
        >
          <IconButton
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-3"
            onClick={() =>
              navigate(CONSTANT_ROUTES.ADD_NEW_LAB_REPORT, {
                state: {
                  patientId: location?.state?.id,
                  patientName: location?.state?.name,
                },
              })
            }
          >
            <span className="d-none d-sm-inline-block ms-1">New</span>
          </IconButton>
        </OverlayTrigger>
      </div>

      <FalconLightBoxGallery images={lightboxImages}>
        {(setImgIndex) => {
          window.addEventListener("openLightbox", (e) => setImgIndex(e.detail));
          return (
            <Row className="g-2">
              {data.map((item) => {
                const relativePath = item.relativeFilePath;

                return (
                  <Col xs={12} md={2} key={item.id}>
                    <Tippy
                      content={renderTooltipContent(item)}
                      placement="top"
                      interactive={true}
                      delay={[200, 300]}
                      maxWidth="none"
                      theme="light-border"
                    >
                      <div
                        className="p-2 text-center cursor-pointer"
                        onClick={() => handleClick(relativePath)}
                      >
                        <div className="mb-2 fw-semibold text-dark">
                          {item.testName}
                        </div>
                        {renderFilePreview(relativePath)}
                      </div>
                    </Tippy>
                  </Col>
                );
              })}
            </Row>
          );
        }}
      </FalconLightBoxGallery>
    </div>
  );
}

const renderTooltipContent = (item) => (
  <div style={{ padding: "8px", maxWidth: "600px" }}>
    <table style={{ tableLayout: "auto", width: "100%" }}>
      <tbody>
        <tr>
          <th
            style={{
              textAlign: "left",
              paddingRight: "1rem",
              whiteSpace: "nowrap",
            }}
          >
            Test Date:
          </th>
          <td>{item.testDate?.split("T")[0]}</td>
        </tr>
        <tr>
          <th
            style={{
              textAlign: "left",
              paddingRight: "1rem",
              whiteSpace: "nowrap",
            }}
          >
            Results:
          </th>
          <td>{item.results}</td>
        </tr>
        <tr>
          <th
            style={{
              textAlign: "left",
              paddingRight: "1rem",
              whiteSpace: "nowrap",
            }}
          >
            Notes:
          </th>
          <td>{item.notes}</td>
        </tr>
        <tr>
          <th
            style={{
              textAlign: "left",
              paddingRight: "1rem",
              whiteSpace: "nowrap",
            }}
          >
            Normal Range:
          </th>
          <td>{item.normalRange}</td>
        </tr>
      </tbody>
    </table>
  </div>
);
